import React from 'react'
import { Card, Separator, List } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { usePermission } from '@fs/zion-permissions'
import RestoreButton from '../RestoreButton/RestoreButton'

const cardWrapper = css`
  & > div {
    display: block;
  }
`

export default function ChangeHistoryCard({ restoreStatus, onFinish, children, date }) {
  const [hasImageOrganizePermission, imageOrganizePermissionCheckStatus] = usePermission(
    'LightyearImageOrganizePermission',
    'LightyearContext'
  )
  const [hasRmsAdminPermission, rmsAdminPermissionCheckStatus] = usePermission('RMSAdminPermission', 'RMSContext')
  const [hasRmsGroupWritePermission, rmsGroupWritePermissionCheckStatus] = usePermission(
    'RMSGroupWritePermission',
    'RMSContext'
  )

  const canRestore =
    [imageOrganizePermissionCheckStatus, rmsAdminPermissionCheckStatus, rmsGroupWritePermissionCheckStatus].every(
      (status) => status === 'loaded'
    ) &&
    hasImageOrganizePermission &&
    (hasRmsAdminPermission || hasRmsGroupWritePermission)

  return restoreStatus ? (
    <>
      <Separator size="xs" />
      <div css={cardWrapper}>
        <Card edges="border">
          <List>{children}</List>
          {canRestore && restoreStatus && (
            <RestoreButton
              isCurrentVersion={restoreStatus.status === 'CURRENT'}
              restoreData={restoreStatus.data}
              onFinish={onFinish}
              wasRemoved={restoreStatus.status === 'REMOVED'}
              date={date}
            />
          )}
        </Card>
      </div>
    </>
  ) : null
}
